/**
 * ETAP 7 – route definitions shared by the Polish (root) and English (/en/) trees.
 * Paths are relative on purpose, so the same list can be mounted under a prefix.
 */
import Index from "@/pages/Index";
import Produkty from "@/pages/Produkty";
import ONas from "@/pages/ONas";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Kontakt from "@/pages/Kontakt";
import PolitykaPrywatnosci from "@/pages/PolitykaPrywatnosci";
import PolitykaCookies from "@/pages/PolitykaCookies";
import SeoAudit from "@/pages/SeoAudit";
import AiGenerator from "@/pages/AiGenerator";
import Kalkulator from "@/pages/Kalkulator";
import Cms from "@/pages/Cms";
import NaklejkiDoming from "@/pages/NaklejkiDoming";
import NaklejkiWypukle from "@/pages/NaklejkiWypukle";
import NaklejkiZLogo from "@/pages/NaklejkiZLogo";
import ZastosowaniaBranzowe from "@/pages/ZastosowaniaBranzowe";
import Realizacje from "@/pages/Realizacje";
import BazaWiedzy from "@/pages/BazaWiedzy";
import BazaWiedzyArtykul from "@/pages/BazaWiedzyArtykul";
import OAuthConsent from "@/pages/OAuthConsent";
import ProductPage from "@/components/product/ProductPage";
import { PRODUCTS } from "@/data/products";
import type { ReactElement } from "react";

export type RouteDef = { path: string; element: ReactElement };

/** Pages available in both languages. */
export const PUBLIC_ROUTES: RouteDef[] = [
  { path: "produkty", element: <Produkty /> },
  { path: "o-nas", element: <ONas /> },
  { path: "blog", element: <Blog /> },
  { path: "blog/:slug", element: <BlogArticle /> },
  { path: "baza-wiedzy", element: <BazaWiedzy /> },
  { path: "baza-wiedzy/:slug", element: <BazaWiedzyArtykul /> },
  { path: "realizacje", element: <Realizacje /> },
  { path: "kontakt", element: <Kontakt /> },
  { path: "polityka-prywatnosci", element: <PolitykaPrywatnosci /> },
  { path: "polityka-cookies", element: <PolitykaCookies /> },
  { path: "kalkulator", element: <Kalkulator /> },
  { path: "naklejki-doming", element: <NaklejkiDoming /> },
  { path: "naklejki-wypukle", element: <NaklejkiWypukle /> },
  { path: "naklejki-z-logo", element: <NaklejkiZLogo /> },
  { path: "zastosowania-branzowe", element: <ZastosowaniaBranzowe /> },
  ...PRODUCTS.map((p) => ({ path: p.slug, element: <ProductPage slug={p.slug} /> })),
];

/** Internal tools – Polish tree only, never mirrored under /en/. */
export const INTERNAL_ROUTES: RouteDef[] = [
  { path: "seo-audit", element: <SeoAudit /> },
  { path: "ai-generator", element: <AiGenerator /> },
  { path: "cms", element: <Cms /> },
  { path: ".lovable/oauth/consent", element: <OAuthConsent /> },
];

export const HOME_ROUTE: RouteDef = { path: "", element: <Index /> };
